import React from 'react'
import { Edit2, Eye } from 'iconsax-react'
import { useTheme } from '@mui/material'

import { useRolesPermissions } from '@SonarCX/providers/RolesPermissionsProvider'
import useStyles from './styles'

const EditingCell = ({ systemRole, data }) => {
  const theme = useTheme()

  const { setOpenModal, setData, setError } = useRolesPermissions()

  const classes = useStyles()

  const clearData = React.useCallback(() => {
    setOpenModal(true)
    setData(data)
    setError(null)
  }, [setOpenModal, setData, data, setError])

  return (
    <div className={classes.root}>
      {!systemRole ? (
        <div>
          <Edit2
            size={theme.size.base}
            className={classes.icon}
            onClick={clearData}
          />
        </div>
      ) : (
        <Eye
          size={theme.size.base}
          className={classes.icon}
          onClick={clearData}
        />
      )}
    </div>
  )
}

export default EditingCell
